import { Component, Inject, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import * as moment from "moment";
import { AlertService } from "src/app/services/alert.service";
import { ManufacturerService } from "src/app/services/manufacturer.service";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-feedbackpopup",
  templateUrl: "./feedbackpopup.component.html",
  styleUrls: ["./feedbackpopup.component.scss"],
})
export class FeedbackpopupComponent implements OnInit {
  form: FormGroup;
  maxDate: Date;
  fileType: number;
  PrintpaymentName: any;
  filesResult: any;
  attachmentlen: any;
  attachmentData: any;
  attachmentsDataSource: any;
  sort: any;
  paginator: any;
  panfiles: any;
  attachmentFile: any[] = [];
  reasonList: any[];
  filterReasonList: any[];
  isDisabled: boolean;

  constructor(
    public dialogRef: MatDialogRef<FeedbackpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedToEdit: any,
    private manufactureService: ManufacturerService,
    private alertService: AlertService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.maxDate = new Date();
    this.allreasonList();
    this.initializeValidators();
    if (this.dataRecievedToEdit.id == 2) {
      this.isDisabled = true;
      this.getgpsMalfunctionActivityLog();
    } else {
      this.isDisabled = false;
    }

  }
  // goToAction() {
  //   if (this.form.valid) {
  //     let data = {
  //       remarks: this.form.value.remarks,
  //       categoryType: this.dataRecievedToEdit.categoryType,
  //       vehicleStatusType: this.dataRecievedToEdit.vehicleStatusType,
  //       machineryUnreachableReasonType: this.form.value.machineryUnreachableReasonType,
  //       lastUpdatedTs: this.dataRecievedToEdit.lastUpdatedTs,
  //       vehicleId: this.dataRecievedToEdit.vehicleId,
  //       regNo: this.dataRecievedToEdit.regNo,
  //       divisionId: this.dataRecievedToEdit.divisionId,
  //       subDivisionId: this.dataRecievedToEdit.subDivisionId,
  //       regionId: this.dataRecievedToEdit.regionId,
  //       sinceWhenTs: moment(this.form.value.sinceWhenTs).format("YYYY-MM-DD"),
  //       driverName: this.dataRecievedToEdit.driverName
  //     };
  //     this.manufactureService
  //       .savemachineryUnreachableReasonType(data)
  //       .subscribe(result => {
  //         if (result) {
  //           this.alertService.result(result, true ,"Updated Successfully");
  //           this.next();
  //         }
  //       });
  //   } else {
  //     this.validateFormControl();
  //   }
  // }
  getgpsMalfunctionActivityLog() {
    this.manufactureService
      .getgpsMalfunctionActivityLog(
        this.dataRecievedToEdit.dataField.id,
        true
      )
      .subscribe((res) => {
        if (res) {
          this.form.patchValue(res);
          this.PrintpaymentName = res.inspectionImagePath;
        }
      });
  }
  validateFormControl() {
    Object.keys(this.form.controls).forEach((field) => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }

  Submit() {
    if (this.form.valid) {
      let payload = {
        vehicleId: this.dataRecievedToEdit.dataField.id,
        remarks: this.form.value.remarks,
        gpsMalfunctionReasonId: this.form.value.gpsMalfunctionReasonId,
        lastUpdatedTs: moment(
          this.dataRecievedToEdit.dataField.lastUpdatedTs
        ).format("YYYY-MM-DD"),
        issueFixedTs: moment(this.form.value.issueFixedTs).format("YYYY-MM-DD"),
        attachment: this.attachmentFile,
      };
      this.manufactureService
        .gpsMalfunctionActivityLogSave(payload)
        .subscribe((res) => {
          if (res) {
            this.dialogRef.close();
          }
        });
    } else {
      this.validateFormControl();
    }
  }

  pickerOpen() {
    //  this.startAt = new Date();
    //  this.maxDate = new Date();
  }
  allreasonList() {
    this.manufactureService.getgpsmalfunctionreason(true).subscribe((res) => {
      this.reasonList = res;
      this.filterReasonList = this.reasonList.slice();
      if (this.filterReasonList.length == 1) {
        this.form.controls["gpsMalfunctionReasonId"].setValue(
          this.reasonList[0].key
        );
      }
    });

    // api/lookup/gpsmalfunctionreason
  }
  initializeValidators() {
    this.form = this.formBuilder.group({
      issueFixedTs: ["", Validators.required],
      remarks: ["", Validators.required],
      // Printpayment: ["", Validators.required],
      gpsMalfunctionReasonId: ["", Validators.required],
    });
  }

  changeClient2() {}
  
  next() {
    this.dialogRef.close();
  }

  downloadInspectionReport() {
    let src =
    environment.imageBaseUrl + "GPSInspectionCopy/" + this.PrintpaymentName;
    window.open(encodeURI(src), "_blank");
  }
  PrintpaymentSelected(event1) {
    const file = event1.target.files[0];
    if (
      file.type === "application/pdf" ||
      file.type === "image/png" ||
      file.type === "image/jpg" ||
      file.type === "image/jpeg"
    ) {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      if (acceptsize <= 2048) {
        this.PrintpaymentName = file.name;
        let checkType = file.type;
        let getFileType = checkType.split("/");
        // this.fileType = getFileType[1]
        if (getFileType[1] == "pdf") {
          this.fileType = 2;
        } else {
          this.fileType = 1;
        }
        if (file) {
          const reader = new FileReader();
          reader.readAsDataURL(event1.target.files[0]);
          reader.onload = (event: any) => {
            this.panfiles = event.target.result;
            this.filesResult = event.target.result.split(",")[1];
            this.form.controls["Printpayment"].setValue(this.filesResult);
            this.form.controls["Printpayment"].setValue(file.name);
            this.attachmentFile.push({
              id: this.attachmentFile.length + 1 - 1,
              base64String: this.filesResult,
              attachmentFilename: file.name,
              fileType: this.fileType,
              attachmentType: 51,
            });
          };
        }
      } else {
        this.alertService.warning(
          "File size is large, Please upload less than 2 MB"
        );
      }
    } else {
      this.alertService.warning("Please upload JPG, JPEG, PNG and PDF only");
    }
  }
  clear(event) {
    event.target.value = null;
  }
}
